(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5104],{

/***/ 37702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuItem_MenuItem; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(66987);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/react.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = (0,objectWithoutProperties/* default */.Z)(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = react.useContext(ListContext/* default */.Z);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = react.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  var children = react.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && (0,isMuiElement/* default */.Z)(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = react.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = react_dom.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(handleOwnRef, ref);

  var componentProps = (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase/* default */.Z;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
      value: childContext
    }, /*#__PURE__*/react.createElement(ContainerComponent, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/react.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
    value: childContext
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: handleRef
  }, componentProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItem_ListItem = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiListItem'
})(ListItem));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js








var MenuItem_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.Z)({}, theme.typography.body1, (0,defineProperty/* default */.Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react.createElement(ListItem_ListItem, (0,esm_extends/* default */.Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,esm_extends/* default */.Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx_m/* default */.Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var MenuItem_MenuItem = ((0,withStyles/* default */.Z)(MenuItem_styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 80973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(71169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 29689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgBrokenFileIcon = function SvgBrokenFileIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      style: {
        enableBackground: 'new 0 0 512 512' },

      xmlSpace: "preserve" },
    props), {}, { children: [/*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", { d: "M444.875 109.792 338.208 3.125c-2-2-4.708-3.125-7.542-3.125h-224C83.146 0 64 19.135 64 42.667v202.667a10.66 10.66 0 0 0 3.125 7.542l42.667 42.667c4.167 4.167 10.917 4.167 15.083 0l56.458-56.458 77.792 77.792a10.634 10.634 0 0 0 7.542 3.125c2.729 0 5.458-1.042 7.542-3.125l57.813-57.813 56.729 37.813a10.637 10.637 0 0 0 13.458-1.333l42.667-42.667c2-2 3.125-4.708 3.125-7.542v-128a10.664 10.664 0 0 0-3.126-7.543zM341.333 36.417l70.25 70.25h-48.917c-11.771 0-21.333-9.573-21.333-21.333V36.417zm85.334 204.5-33.354 33.354-56.729-37.813c-4.25-2.833-9.854-2.25-13.458 1.333l-56.458 56.458-77.792-77.792a10.634 10.634 0 0 0-7.542-3.125 10.636 10.636 0 0 0-7.542 3.125l-56.458 56.458-32-32V42.667c0-11.76 9.563-21.333 21.333-21.333H320v64C320 108.865 339.146 128 362.667 128h64v112.917z" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", { d: "M441.417 299.479c-3.958-1.677-8.583-.74-11.625 2.313l-36.479 36.479-56.729-37.813a10.65 10.65 0 0 0-13.458 1.333l-56.458 56.458-77.792-77.792c-4.167-4.167-10.917-4.167-15.083 0l-56.458 56.458L82.21 301.79c-3.063-3.052-7.646-3.979-11.625-2.313a10.672 10.672 0 0 0-6.583 9.854v160C64 492.865 83.146 512 106.667 512h298.667c23.52 0 42.666-19.135 42.666-42.667v-160c0-4.312-2.604-8.208-6.583-9.854zm-14.75 169.854c0 11.76-9.563 21.333-21.333 21.333H106.667c-11.771 0-21.333-9.573-21.333-21.333v-134.25l24.458 24.458c4.167 4.167 10.917 4.167 15.083 0l56.458-56.458 77.792 77.792c4.167 4.167 10.917 4.167 15.083 0l57.813-57.813 56.729 37.813a10.637 10.637 0 0 0 13.458-1.333l24.458-24.458v134.249z" })] })));};



/* harmony default export */ __webpack_exports__["Z"] = (SvgBrokenFileIcon);

/***/ }),

/***/ 87977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["data-testid"];















var EmptyResults = function EmptyResults(_ref) {var _ref$dataTestid = _ref[
  'data-testid'],dataTestId = _ref$dataTestid === void 0 ? 'EmptyResults' : _ref$dataTestid,
  props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);return /*#__PURE__*/(

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      className: props.className,
      my: "50px",
      flexDirection: "column",
      alignItems: "center", children: [/*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "30px", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { name: props.icon, fontSize: "84px", color: "#7D7D7D;" }),
        props.children && props.children] }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsText */ .xM, { children: props.title }) }),

      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsDescription */ .ZE, { children: props.description }) }) :

      null,
      props.action ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsTextAction */ .aC, { children: props.action }) }) :

      null,
      props.button ? props.button : null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (EmptyResults);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 94997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image; },
/* harmony export */   "Xd": function() { return /* binding */ BackgroundImage; }
/* harmony export */ });
/* unused harmony export Ratio */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["className", "objectFit"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Image = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].img.withConfig({ displayName: "ThumbnailWithRatio__Image", componentId: "sc-pg90bj-0" })(["position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"]);








var Ratio = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__Ratio", componentId: "sc-pg90bj-1" })(["position:relative;padding-top:", ";"],

function (props) {return props.ratio ? props.ratio : '56.25%';});


var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__BackgroundImage", componentId: "sc-pg90bj-2" })(["width:100%;height:auto;position:absolute;top:0;left:0;bottom:0;right:0;background-size:cover;background-position:center;width:100%;height:100%;box-shadow:", ";", ";", ";", ";"],












function (props) {return (
    props.shadow && "inset 0px -112px 68px -64px rgba(0,0,0,0.75)");},
function (props) {return (
    props.withRadius && (
    props.large ? "\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n          border-top-left-radius: 5px;\n          border-bottom-left-radius: 5px;\n          @media (max-width: ".concat(





    props.theme.viewports.mobile, "px) {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n            border-top-left-radius: 5px;\n            border-top-right-radius: 5px;\n          }\n        ") : "\n          border-bottom-right-radius: 0;\n          border-bottom-left-radius: 0;\n          border-top-left-radius: 5px;\n          border-top-right-radius: 5px;\n        "));},












function (props) {return (
    props.isProgram ? "\n          border-radius: 3px;\n        " :



    null);},
function (props) {return (
    props.isLocked ? "\n          overflow: hidden;\n          &:before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            opacity: 0.8;\n            background-color: #9dc9c7;\n          }\n          &:after {\n            font-family: 'ygb-font' !important;\n            speak: none;\n            font-style: normal;\n            font-weight: normal;\n            font-variant: normal;\n            text-transform: none;\n            z-index: 1;\n            /* Better Font Rendering =========== */\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            content: '\\e94b';\n            height: 24px;\n            width: 24px;\n            color: white;\n            position: absolute;\n            top: calc(50% - 12px);\n            left: calc(50% - 12px);\n            text-align: center;\n            line-height: 24px;\n          }\n        " :


































    null);});


var PLACEHOLDER_IMAGE =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcWw8AAf8BPlp9PLwAAAAASUVORK5CYII=';

var ThumbnailWithRatio = function ThumbnailWithRatio(_ref)



{var _ref$className = _ref.className,className = _ref$className === void 0 ? null : _ref$className,_ref$objectFit = _ref.objectFit,objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Ratio, { className: className, ratio: props.ratio, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Image, {
        src: props.path || PLACEHOLDER_IMAGE,
        objectFit: objectFit,
        loading: "lazy" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BackgroundImage, _objectSpread(_objectSpread(_objectSpread({},
      props),
      props.isLocked ? { 'data-locked': true } : {}), {}, { children:

        props.children }))] }));



};

ThumbnailWithRatio.toString = Ratio.toString;

/* harmony default export */ __webpack_exports__["ZP"] = (ThumbnailWithRatio);

/***/ }),

/***/ 45330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Input = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({ displayName: "Input2__Input", componentId: "sc-1orwxqf-0" })(["width:100%;background-color:", ";padding:11px;font-size:16px;outline:0;border:1px solid ", ";border-top-left-radius:5px;border-bottom-left-radius:5px;", ""],





function (props) {return props.theme.colors.neutrals.white;},




function (props) {return (
    props.errorStyle ?
    props.theme.colors.secondary['red-1'] :
    props.theme.colors.interactive['color-18']);},


function (props) {return (
    props.borderRadiusComplete ? "\n          border-top-right-radius: 5px;\n          border-bottom-right-radius: 5px;\n        " :




    '');});
















var Input2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
function (props, ref) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Input, _objectSpread({
      ref: ref,
      type: props.type,
      id: props.id,
      value: props.value,
      readOnly: props.readOnly,
      onChange: props.onChange,
      onClick: props.onClick,
      errorStyle: props.errorStyle,
      style: props.style,
      borderRadiusComplete: props.borderRadiusComplete },
    props)));});




/* harmony default export */ __webpack_exports__["Z"] = (Input2);

/***/ }),

/***/ 76611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37702);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94924);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["native"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var StyledSelectWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu).withConfig({ displayName: "Select__StyledSelectWrapper", componentId: "sc-e5dpz5-0" })(["position:relative;.MuiInput-underline:after{border-color:transparent;}.MuiInput-underline:hover:not(.MuiInput-disabled):not(.MuiInput-focused):not(.MuiInput-error):before{border:0;}.MuiInput-underline:before{border:0;}.MuiSelect-select:focus{background-color:transparent;}.MuiSelect-nativeInput{position:absolute;opacity:0;}"]);





















var styles = {
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize' } };



var GetStartedSectionStyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' } }).withConfig({ displayName: "Select__GetStartedSectionStyledSelect", componentId: "sc-e5dpz5-1" })(["width:100%;height:100%;.root{width:100%;height:100%;border:0;border-radius:5px;background-color:white;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);}.select{padding:14px;font-size:16px;font-weight:600;}"]);



















var StyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' } }).withConfig({ displayName: "Select__StyledSelect", componentId: "sc-e5dpz5-2" })(["width:100%;height:100%;.root{width:100%;height:100%;border:solid 1px #eaeaea;border-radius:5px;}.select{padding:12px 24px;font-size:13px;min-width:100px;}"]);
















var SelectItem = function SelectItem(props) {
  var _native = props["native"],rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, _excluded);
  return _native ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("option", _objectSpread({}, rest)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({}, rest));
};























var SelectDropDown = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize' } })(

function (props) {
  var valueKey = props.valueKey ? props.valueKey : 'value';
  var displayTextKey = props.displayTextKey ? props.displayTextKey : 'name';
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSelectWrapper, { className: props.className, children:
      props.getStartedStyling ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(GetStartedSectionStyledSelect, {
        id: props.id,
        name: props.name,
        value: props.selectedValue,
        onChange: props.onChange,
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right' },

          transformOrigin: {
            vertical: 'top',
            horizontal: 'right' },

          classes: {
            paper: props.classes.paper } },


        defaultValue: props.defaultValue, children:


        props.options.map(function (item, index) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { value: item[valueKey], children:
              item[displayTextKey] }, index));}) }) : /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSelect, {
        id: props.id,
        name: props.name,
        "native": props["native"],
        value: props.selectedValue,
        onChange: props.onChange,
        disabled: props.disabled,
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right' },

          transformOrigin: {
            vertical: 'top',
            horizontal: 'right' },

          classes: {
            paper: props.classes.paper } },


        defaultValue: props.defaultValue, children:


        props.options.map(function (item, index) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectItem, {

              value: item[valueKey],
              "native": props["native"], children:

              item[displayTextKey] }, index));}) }) }));






});

/* harmony default export */ __webpack_exports__["Z"] = (SelectDropDown);

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ }),

/***/ 75115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modals_InstructorModal; }
});

// UNUSED EXPORTS: ButtonSC

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(4338);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/layout/Span.js
var Span = __webpack_require__(88865);
// EXTERNAL MODULE: ./components/ThumbnailWithRatio.js
var ThumbnailWithRatio = __webpack_require__(94997);
// EXTERNAL MODULE: ./components/typography/Paragraph.js
var Paragraph = __webpack_require__(36225);
// EXTERNAL MODULE: ./skeletons/BaseSkeleton.tsx
var BaseSkeleton = __webpack_require__(30794);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./skeletons/InstructorModalSkeleton.js





var InstructorModalSkeleton = function InstructorModalSkeleton() {return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(ThumbnailWithRatio/* default */.ZP, { path: "", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { as: BaseSkeleton/* default */.Z, animation: true }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { height: 10, width: 100, marginBottom: 20 }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { height: 10, width: 100, marginBottom: 20 }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { height: 10, width: 60, marginBottom: 20 })] }));};



/* harmony default export */ var skeletons_InstructorModalSkeleton = (InstructorModalSkeleton);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./components/EmptyResults.tsx
var EmptyResults = __webpack_require__(87977);
// EXTERNAL MODULE: ./assets/BrokenFileIcon.js
var BrokenFileIcon = __webpack_require__(29689);
;// CONCATENATED MODULE: ./organisms/modals/InstructorModal.tsx
var _templateObject;














var GET_INSTRUCTOR = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query instructor($id: ID!) {\n    instructor(id: $id) {\n      id\n      slug\n      name\n      slug\n      description\n      assets {\n        externalImage\n      }\n      speciality\n      location\n      webpage\n    }\n  }\n"])));

















var ButtonSC = styled_components_browser_esm["default"].a.withConfig({ displayName: "InstructorModal__ButtonSC", componentId: "sc-1onpl1t-0" })(["display:block;width:100%;text-align:center;margin:0;color:white;margin-left:5px;margin-right:5px;padding:12px 25px;border-radius:2px;border:1px solid ", ";background-color:", ";font-weight:600;color:#fff;text-decoration:none;font-size:13px;cursor:pointer;"],









function (props) {return props.theme.colors.primary['blue-2'];},
function (props) {return props.theme.colors.primary['blue-2'];});







var InstructorModal_EmptyResults = (0,styled_components_browser_esm["default"])(EmptyResults/* default */.Z).withConfig({ displayName: "InstructorModal__EmptyResults", componentId: "sc-1onpl1t-1" })(["text-align:center;"]);



var BrokenFile = (0,styled_components_browser_esm["default"])(BrokenFileIcon/* default */.Z).withConfig({ displayName: "InstructorModal__BrokenFile", componentId: "sc-1onpl1t-2" })(["width:100px;height:100px;fill:", ";"],


function (_ref) {var theme = _ref.theme;return theme.colors.neutrals['gray-3'];});


var InstructorModal = function InstructorModal(props) {
  var _useState = (0,react.useState)(false),open = _useState[0],setOpen = _useState[1];
  var _useLazyQuery = (0,useLazyQuery/* useLazyQuery */.t)(GET_INSTRUCTOR, {
    variables: { id: props.slug } }),_useLazyQuery2 = (0,slicedToArray/* default */.Z)(_useLazyQuery, 2),loadInstructor = _useLazyQuery2[0],_useLazyQuery2$ = _useLazyQuery2[1],loading = _useLazyQuery2$.loading,data = _useLazyQuery2$.data;


  var handleOpenModal = /*#__PURE__*/function () {var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                loadInstructor());case 2:
              setOpen(true);case 3:case "end":return _context.stop();}}}, _callee);}));return function handleOpenModal() {return _ref2.apply(this, arguments);};}();


  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
  };

  var content = null;
  if (loading) {
    content = /*#__PURE__*/
    (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(skeletons_InstructorModalSkeleton, {}) });


  } else if (data !== null && data !== void 0 && data.instructor) {
    var instructor = data.instructor;
    content = /*#__PURE__*/
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Body */.uT, { pushFooterDown: 120, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 30, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(ThumbnailWithRatio/* default */.ZP, { path: instructor.assets.externalImage }) }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { mb: 30, children: [/*#__PURE__*/
          (0,jsx_runtime.jsxs)(Paragraph.P, { color: "#242424", children: [/*#__PURE__*/
            (0,jsx_runtime.jsxs)(Span/* default */.Z, { bold: true, color: "#242424", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "teacher_modal.speciality", message: 'Speciality' }), ":"] }),
            ' ',
            instructor.speciality] }), /*#__PURE__*/


          (0,jsx_runtime.jsxs)(Paragraph.P, { color: "#242424", children: [/*#__PURE__*/
            (0,jsx_runtime.jsxs)(Span/* default */.Z, { bold: true, color: "#242424", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "teacher_modal.location", message: 'Location' }), ":"] }),
            ' ',
            instructor.location] }), /*#__PURE__*/

          (0,jsx_runtime.jsxs)(Paragraph.P, { color: "#242424", children: [/*#__PURE__*/
            (0,jsx_runtime.jsxs)(Span/* default */.Z, { bold: true, color: "#242424", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "teacher_modal.homepage", message: 'Homepage' }), ":"] }),
            ' ', /*#__PURE__*/
            (0,jsx_runtime.jsx)(Link/* default */.ZP, { href: instructor.webpage, target: '_blank', children:
              instructor.webpage })] })] }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 30, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Paragraph.P, {
            lineHeight: "23px",
            color: "#242424",
            dangerouslySetInnerHTML: {
              __html: instructor.description } }) })] }), /*#__PURE__*/




      (0,jsx_runtime.jsx)(base/* Footer */.$_, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(ButtonSC, { href: "/team/".concat(instructor.slug), target: "_blank", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "teacher_modal.go_to_profile", message: 'Visit profile' }) }) })] });




  } else {
    content = /*#__PURE__*/
    (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(InstructorModal_EmptyResults, {
        title: "",
        description: /*#__PURE__*/
        (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
          id: "public_profile.error_msg",
          message: "Sorry, it seems like there's an issue displaying the profile. Please try again in a bit" }), children: /*#__PURE__*/



        (0,jsx_runtime.jsx)(BrokenFile, {}) }) });



  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
      props.children(handleOpenModal), /*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Modal */.u_, {
        open: open,
        handleClose: handleCloseModal,
        customWidth: "600px", children: [/*#__PURE__*/


        (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: handleCloseModal }),
        content] })] }));



};

/* harmony default export */ var modals_InstructorModal = (InstructorModal);

/***/ }),

/***/ 43558:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/programs",
      function () {
        return __webpack_require__(15783);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,3088,4568,6394,5675,4924,8397,1977,4746,2661,8618,226,1489,9774,2888,179], function() { return __webpack_exec__(43558); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);